export const truncateDecimal = (decimalVal: number) => {
  if (decimalVal < 0) {
    return 0;
  }

  return Math.floor(decimalVal);
};
